import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Http } from '@angular/http';
import { TranslateService } from '@ngx-translate/core';
import { saveAs as importedSaveAs } from 'file-saver';
import { sortBy } from 'lodash';
import * as moment from 'moment';
import { NgProgress } from 'ngx-progressbar';
import { Observable } from 'rxjs/Observable';
import { Modal } from '../../../../node_modules/ngx-modal';
import { ApiUrlConstants } from '../../common/constants/api.constants';
import { AccessLevel } from '../../common/enums/access-level.enum';
import { Permission } from '../../common/enums/permission.enum';
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { CommonConstant } from '../../shared/constants/common.constants';
import { Country } from '../../shared/interface/country.interface';
import { StoreConfig } from '../../shared/interface/StoreConfig.interface';
import { UserInfo } from '../../shared/interface/user-info.interface';
import { CacheService } from '../../shared/services/cache.service';
import { CommonService } from '../../shared/services/common.service';
import { MessageService } from '../../shared/services/message.service';
import { Utils } from '../../shared/Utils/utils';
import { CommonMessage } from '../common/common-messages';
import { MemberType, SearchResponseType } from '../common/constants';
import { StatusConstants } from '../constants/status.constants';
import { OperatingCountryEnums } from '../enums/countries.enums';
import { NotificationType } from '../enums/notification-types.enum';
import { Status } from '../enums/ticket-status.enum';
import { Priority, SourceType, SubtypesEnums, TicketType } from '../enums/ticket-type.enum';
import { BusinessEntity } from '../interface/businessentity';
import { EmailNotificationFlagIbfo } from '../interface/emailNotificationFlagInfo';
import { FBOResponse } from '../interface/fbo-response';
import { MemberSearchByFboIdResponse } from '../interface/member-search-by-fboid-response';
import { ProfileInformation } from '../interface/profile-info';
import { SearchRequest } from '../interface/search-request';
import { CopyToSearchResponse, CopyToUserResponse } from '../interface/ticketingsystem/copy-to-search-response.interface';
import { CopyToUser } from '../interface/ticketingsystem/copy-to-users.interface';
import { DistributorInfo } from '../interface/ticketingsystem/distributor-info';
import { CreateTicketRequest } from '../interface/ticketingsystem/ticket-create';
import { DeleteModal } from '../models/delete-modal';
import { SearchSettingsModal } from '../models/searchSettings-modal';
import { TicketTabInfo } from '../models/tickets-tab.model';
import { CustomerService } from '../services/customer.service';
import { DepartmentService } from '../services/department.service';
import { OrderService } from '../services/order.service';
import { DateConstants } from '../constants/date.constants';
import { MemberTypeEnum } from '../enums/member-type.enum';
import { AccountRestrictionStatus } from '../../common/enums/account-restricted.enum';
import { environment } from '../../../environments/environment';
import { DisplayNameFormatPipe } from '../../common/pipes/display-name-format.pipe';

@Component({
    selector: 'work-ticket-edit',
    templateUrl: '../templates/template1/views/work-ticket-edit.component.html',
    styleUrls: [
        '../templates/template1/themes/default/css/tickets-edit.less'
    ],
    providers: [DisplayNameFormatPipe]
})
export class EditWorkTicket implements OnInit {
    @ViewChild('ticketType') ticketType: ElementRef;
    @Input() distributorInfo: DistributorInfo;
    @Input() tabIndex: number;
    @Input() ticketID: number;
    @Input() isTeamTicket: boolean;
    @Input() isFormTicket: boolean;
    @Input() isFdTicket: boolean;
    fboProfileDetail: ProfileInformation;
    workTicketDistributorInfo: DistributorInfo;
    ticketingModel: any;
    operatingCountryId: String;
    existFiles: any = [];
    attachmentsLength: number = 0;
    orderInfo: any;
    countries: any;
    allCountries: any;
    businessEntities: BusinessEntity[] = [];
    ticketEditForm: FormGroup;
    ticketCloseForm: FormGroup;
    sourceTypes: any[];
    ticketPriorities: any[];
    users: any[];
    sourceTypesEnum: any = SourceType;
    userInfo: UserInfo;
    isTicketAssign: any;
    isTicketAssignPermission: boolean = true;
    ticketTypes: any[];
    orderTypeId: number;
    productTypeId: number;
    departments: any[];
    subTypes: any[];
    statuses: any[];
    initialStatuses: any[];
    locationTypes: any[];
    ticketActivityLogList: any[] = [];
    enableLocationType: boolean = false;
    fboSearchResultModel: FBOResponse;
    searchComponentSettings: SearchSettingsModal;
    uploader: any;
    isTicketClosed: boolean;
    isDesc: Boolean = true;
    isLoading: boolean = false;
    count: number = 0;
    sortColumn: String;
    ticketResponse: any;
    uploadResponse: any = [];
    closedReasons: any[];
    isSubmitted: boolean = true;
    isStatusChanged: boolean = false;
    dueDateFormat: Date;
    inValidOrderNumber: boolean;
    dueDate: any; // we are getting Moment Object
    showDatePicker = false;
    onLoad: boolean = true;
    fboIdFound: boolean;
    skipDueDateNStatusOnLoad: boolean = true;
    skipAssignToOnLoad: boolean = true;
    deleteModal: DeleteModal;
    @ViewChild('closeTicketModal') closeTicketPopup: Modal;
    @ViewChild('editTicketCancelConfirmationModal') editTicketCancelConfirmationModal: Modal;
    skipDeptOnLoad: boolean = true;
    ticketActivityChangeData: String = '';
    ticketClosed: boolean;
    ticketReopen: boolean;
    modelSubmit: boolean;
    disableCreate: boolean;
    validWebOrderNumber: boolean;
    isTicketAddNoteNotes: boolean;
    storeInfo: StoreConfig;
    invalidMembersearch: boolean;
    isTicketClosePermission: boolean;
    onloadAttachments: any[] = [];
    isTicketReopenPermission: boolean;
    emailNotificationFlagIbfo: EmailNotificationFlagIbfo;
    customerServiceAccessLevelId: number = AccessLevel.Customer_Service;
    ticket = new CreateTicketRequest();
    isoCodeThree: string;
    maxDescriptionChars = 20000;
    descriptionFocus = false;
    momentConstructor: (value?: any) => moment.Moment = (<any>moment).default || moment;
    phoneNumberFormat = CommonConstant.DefaultPhoneNumberFormat;
    isEmail: boolean;
    memberTypeEnum = MemberTypeEnum;
    @ViewChild('ticketActivityDetailsModal') ticketActivityDetailsModal: Modal;
    accountRestriction: boolean;
    accountViewPermission: boolean;
    memberDetails: { fboId: any; firstName: any; lastName: any; memberLevel: any; };
    DistributorInfo: any;
    enableFileUploadToPrivate: Boolean = environment.enableFileUploadToPrivate;
    constructor(private _customerservice: CustomerService, private _messageService: MessageService, private _formbuilder: FormBuilder, private _cacheService: CacheService,
        private _commonService: CommonService, private departmentService: DepartmentService, private ngProgress: NgProgress, private _translatePipe: TranslateService,
        private _orderservice: OrderService, private _customerService: CustomerService, private displayNamePipe : DisplayNameFormatPipe,
        private _http: Http) {
    }
    FBOManageTicketPermissions: any[] = [
        Permission.MANAGE_TICKETS_CREATE,
        Permission.MANAGE_DEPARTMENT_TICKETS_ASSIGN,
        Permission.MANAGE_TICKETS_ADD_NOTE_ATTACHMENT,
        Permission.MANAGE_TICKETS_VIEW
    ];
    accountRestrictionPermission: any[] = [Permission.ACCOUNT_RESTRICTED_VIEW, Permission.ACCOUNT_RESTRICTED_MANAGE];
    ManageDepartmentPermissions: any[] = [
        Permission.MANAGE_DEPARTMENT_TICKETS_CLOSE,
        Permission.MANAGE_DEPARTMENT_TICKETS_RE_OPEN,
        Permission.MANAGE_DEPARTMENT_TICKETS_EDIT,
        Permission.MANAGE_DEPARTMENT_TICKETS_SELF_ASSIGN,
        Permission.MANAGE_DEPARTMENT_TICKETS_REASSIGN,
        Permission.MANAGE_DEPARTMENT_TICKETS_ASSIGN
    ];

    ngOnInit(): void {
        this.searchComponentSettings = new SearchSettingsModal(5, 0);
        this.userInfo = this._cacheService.get(CacheKey.UserInfo);
        this._commonService.getUserInformation(this.userInfo.userName).subscribe(data => {
            if (data) {
                this._cacheService.set(CacheKey.UserInfo, data);
                this.userInfo = data;
                this.isTicketAssign = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBOManageTicketPermissions[1] + "]"), AccessLevel.Customer_Service);
                this.isTicketAddNoteNotes = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBOManageTicketPermissions[2] + ']'), AccessLevel.Customer_Service);
            }
        });
        this.deleteModal = new DeleteModal(this.doNotRemoveFormData.bind(this),
            this.doNotRemoveFormData.bind(this), this.doNotRemoveFormData.bind(this));
        this.deleteModal.viewActionButtons = false;
        this.preloadDistributorInfo();
        this.getEmailNotificationFlagInfo(this.userInfo.userId, this.ticketID);
        this.accountViewPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.accountRestrictionPermission[0] + ']'), AccessLevel.Customer_Service);
    }
    getOperatingCountryById(operatingCountryId: String) {
        this._customerservice.getOperatingCountryById(operatingCountryId).subscribe((response) => {
            if (response) {
                let country = response;
                country ? this.ticketingModel.operatingCountryName = country.name : null;
                this.getAllCountries(country.value);
            }
        });
    }
    getStoreConfig(): void {
        this._orderservice.getStoreInfo(CommonConstant.Default_Country).subscribe(response => {
            if (response) {
                this.storeInfo = response;
                this.getTicketById(this.ticketID);
                this.getTicketActivityLog(this.ticketID);
                this.getClosedReasons();
                this.getTicketPriorities();
                this.getLocationTypes();
            }
        });
    }

    /**
     *
     * @param userId getting email notification Flag information
     * @param ticketNumber
     */
    getEmailNotificationFlagInfo(userId: number, ticketID: number) {
        this._customerservice.getEmailNotificationFlagIbfo(userId, ticketID).subscribe((response) => {
            if (response) {
                this.emailNotificationFlagIbfo = response;
                this.emailNotificationFlagIbfo.ticketNumber = ticketID.toString();
                this.getStoreConfig();
            }
        });
    }
    /**
      * Build form
      */
    buildForm() {
        this.ticketEditForm = this._formbuilder.group(
            {
                operatingCountry: [this.ticketingModel.operatingCountryId ? this.ticketingModel.operatingCountryId : '', Validators.required],
                country: [this.isoCodeThree ? this.isoCodeThree : ''],
                source: [SourceType.Phone, Validators.required],
                priority: [this.ticketingModel ? this.ticketingModel.priorityId : '', Validators.required],
                assignTo: [this.ticketingModel.assignedToId ? this.ticketingModel.assignedToId : ''],
                department: [this.ticketingModel.departmentId && this.ticketingModel.departmentName ? this.ticketingModel.departmentId : '', Validators.required],
                ticketType: [this.ticketingModel.typeId ? this.ticketingModel.typeId : '', Validators.required],
                subType: [this.ticketingModel.subTypeId ? this.ticketingModel.subTypeId : '', Validators.required],
                subject: [this.ticketingModel.subject ? this.ticketingModel.subject : '', Validators.required],
                description: [this.ticketingModel.description ? this.ticketingModel.description : ''],
                dueDate: [this.dueDate ? this.dueDate : ''],
                orderId: [this.ticketingModel.orderId ? this.ticketingModel.orderId : ''],
                locationType: [this.ticketingModel.locationTypeId ? this.ticketingModel.locationTypeId : ''],
                status: [this.ticketingModel.statusId ? this.ticketingModel.statusId : '', Validators.required],
                notes: [this.ticketingModel.note ? this.ticketingModel.note : ''],
                memberId: [this.ticketingModel ? this.ticketingModel.memberId : ''],
                copyTo: [[]],
                sendMailNotification: [this.emailNotificationFlagIbfo ? this.emailNotificationFlagIbfo.sendMailNotification : false],
                sourceIdentifierValue: [this.ticketingModel ? this.ticketingModel.sourceIdentifierValue : '',
                isNaN(this.ticketingModel.sourceIdentifierValue) ? '' : [Validators.required, Utils.PhoneNumValidationRule, Utils.PhoneNumLengthValidationRule]]
            });
        if (this.ticketEditForm.controls['memberId'].valid && this.ticketEditForm.controls['memberId'].value
            && this.ticketEditForm.controls['memberId'].value.length === 12) {
            this.ticketEditForm.controls['memberId'].setValue(this.ticketEditForm.controls['memberId'].value.replace(/(\d{3})(\d{3})(\d{3})(\d{3})/, '$1-$2-$3-$4'));
        }
        if (this.ticketingModel.statusId === Status.Closed) {
            this.isStatusChanged = true;
            this.ticketEditForm.controls['status'].setValue(Status.InProgress);
        }
        this.rebindCopyToUsers();
        this.invalidMembersearch = false;
        this.fboIdFound = false;
        this.disableCreate = false;
        this.isEmail = isNaN(this.ticketEditForm.controls['sourceIdentifierValue'].value);
    }

    /**
     * @description This method used to set value for copy to field
     * @date 2019-11-19
     * @memberof EditWorkTicket
     */
    rebindCopyToUsers(): void {
        if (this.ticketingModel && this.ticketingModel.copyToUsers && this.ticketingModel.copyToUsers.length) {
            const users = [];
            this.ticketingModel.copyToUsers.forEach(item => {
                const user = {
                    value: item.firstName + ' ' + item.lastName + ' ' + item.username,
                    display: item.firstName + ' ' + item.lastName + ' ' + item.username,
                    displayName: item.firstName + ' ' + item.lastName,
                    firstName: item.firstName, lastName: item.lastName, userId: item.userId, username: item.username
                };
                users.push(user);
            });
            this.ticketEditForm.controls['copyTo'].setValue(users);
        }
    }

    /**
     * @description prepare member search request by using FBO ID
     * @date 2019-10-15
     * @private
     * @returns {SearchRequest}
     * @memberof EditWorkTicket
     */
    private prepareMemberByIdRequestForSearch(): SearchRequest {
        const searchValue = this.getDistibutorID();
        const searchRequest: SearchRequest = {
            pageNumber: 1,
            pageSize: 10,
            sort: 'DESC',
            isAdvancedSearch: false,
            searchBy: 'MEMBER',
            sortOrder: ['fboId'],
            searchCriteria: [
                {
                    searchKey: 'FBOID',
                    searchValue: searchValue
                }
            ]
        };
        return searchRequest;
    }

    private getDistibutorID(): string {
        const distributorIdPattern = /^\d\d\d-\d\d\d-\d\d\d-\d\d\d$/;
        const distibutorID = this.ticketEditForm.controls['memberId'].value;
        if (new RegExp(distributorIdPattern).test(distibutorID)) {
            let fboId = distibutorID;
            fboId = fboId.replace(/-|\s/g, '');
            return fboId;
        }
    }

    /**
     * @description  get member search by fbo id
     * @date 2019-10-15
     * @memberof EditWorkTicket
     */
    searchMemberByFboId(): void {
        this.disableCreate = true;
        if (this.ticketEditForm.controls['memberId'].value) {
            this.fboSearchResultModel = null;
            this.fboIdFound = false;
            this.invalidMembersearch = false;
            let fboId = this.ticketEditForm.controls['memberId'].value;
            fboId = fboId.replace(/-|\s/g, '');
            if (fboId.match(/[a-zA-Z]/) || fboId.length != 12) {
                this.invalidMembersearch = true;
            } else {
                this.ticketEditForm.controls['memberId'].setValue(fboId);
                if (this.ticketEditForm.controls['memberId'].valid && this.ticketEditForm.controls['memberId'].value
                    && this.ticketEditForm.controls['memberId'].value.length === 12) {
                    this.ticketEditForm.controls['memberId'].setValue(this.ticketEditForm.controls['memberId'].
                        value.replace(/(\d{3})(\d{3})(\d{3})(\d{3})/, '$1-$2-$3-$4'));
                    this.ticketEditForm.controls['memberId'].updateValueAndValidity();
                }
                const distributorId = this.getDistibutorID();
                if (distributorId) {
                    this._customerservice.getFBOProfileInfoFromTitan(distributorId).subscribe(response => {
                        if (response && response.isSuccess) {
                            const distributorId = this.getDistibutorID();
                            this._commonService.getMemberStatus(+distributorId).subscribe(accountInfo => {
                                const fboId =response.fboId;
                                const firstName =response.firstName;
                                const lastName =response.lastName;
                                const memberlevel = response.memberLevel;
                                if(accountInfo && accountInfo.status === AccountRestrictionStatus.RESTRICTED && !this.accountViewPermission){
                                    this.accountRestriction = true;
                                    const memberDetails = {
                                        fboId: fboId,
                                        firstName: firstName,
                                        lastName: lastName,
                                        memberLevel: memberlevel
                                    };
                                    this.memberDetails = memberDetails;
                                    this.ticketEditForm.controls['memberId'].setValue('');
                                } else {
                                    this.getFboInformation(response);
                                }
                            })
                        } else {
                            this.getSearchDistributorInfoFromAs400();
                        }
                    }, (error: any) => {
                        this.getSearchDistributorInfoFromAs400();
                    });
                }
            }
        } else {
            this.fboSearchResultModel = null;
            this.fboIdFound = false;
            this.invalidMembersearch = false;
            this.disableCreate = false;
        }
    }

    getFboInformation(response) {
        if (response.firstName && response.lastName) {
            const middleName = response.displayMiddleName && response.middleName ? response.middleName : '';
            this.workTicketDistributorInfo.name = response.firstName + ' ' + (middleName ? middleName + ' ' : '') + response.lastName;
        }
        if (response.fboId) {
            this.workTicketDistributorInfo.distributorId = response.fboId;
        }

        this.disableCreate = false;
        this.fboIdFound = true;
        this.ticketingModel.callerName = this.ticketingModel.callerName ? this.ticketingModel.callerName : this.workTicketDistributorInfo.name;
        this.ticketingModel.sourceIdentifierValue = this.ticketingModel.sourceIdentifierValue ? this.ticketingModel.sourceIdentifierValue :
            (this.ticketingModel.sourceId === SourceType.Email || this.ticketingModel.sourceId === SourceType.Online_Form) ? response.emailId : response.mobile;
    }

    closeModal(status: boolean){
        this.accountRestriction = status;
    }

    /**
     * @description
     * @date 2019-10-24
     * @private
     * @param {string} [url]
     * @memberof EditWorkTicket
     */
    private getSearchDistributorInfoFromAs400(url?: string): void {
        const searchRequest: SearchRequest = this.prepareMemberByIdRequestForSearch();
        this._customerservice.getSearchResults(searchRequest, url)
            .subscribe((response: MemberSearchByFboIdResponse) => {
                if (response && response.fboSearchResultModelList && response.fboSearchResultModelList.length) {
                    const fboMemberDetails =response.fboSearchResultModelList[0];
                    const fboMemberId = +fboMemberDetails.fboId;
                    this._commonService.getMemberStatus(fboMemberId).subscribe(accountInfo => {
                        const fboId = fboMemberDetails.fboId;
                        const firstName =fboMemberDetails.fullName;
                        const memberlevel = this._commonService.getMemberLevel(fboMemberDetails.memberLevelID);
                        if(accountInfo && accountInfo.status === AccountRestrictionStatus.RESTRICTED && !this.accountViewPermission){
                            this.accountRestriction = true;
                            const memberDetails = {
                                fboId: fboId,
                                firstName: firstName,
                                lastName: '',
                                memberLevel: memberlevel
                            };
                            this.memberDetails = memberDetails;
                            this.ticketEditForm.controls['memberId'].setValue('');
                        } else {
                            if (response.status === SearchResponseType.COMPLETED) {
                                this.searchSuccess(response);
                            } else {
                                this.searchPolling(response);
                            }
                        }
                    })
                }
            }, error => {
                this.searchErrorResponse(error);
            }, () => {
                this.isLoading = false;
            });
    }

    /**
     * @description search success when response
     * @date 2019-10-15
     * @param {*} response
     * @memberof EditWorkTicket
     */
    searchSuccess(response): void {
        if (response && response.fboSearchResultModelList && response.fboSearchResultModelList.length > 0) {
            this.fboSearchResultModel = response.fboSearchResultModelList[0];
            this.workTicketDistributorInfo = {
                distributorId: (this.fboSearchResultModel.fboId ? this.fboSearchResultModel.fboId : '') as string,
                name: (this.fboSearchResultModel.fullName ? this.fboSearchResultModel.fullName : '') as string,
                contactNumber: (this.fboSearchResultModel.phone ? this.fboSearchResultModel.phone : '') as string,
                email: (this.fboSearchResultModel.email ? this.fboSearchResultModel.email : '') as string,
                level: '',
                memberType: (this.fboSearchResultModel.memberType ? this.fboSearchResultModel.memberType : '') as string,
                memberId: 0,
                memberTypeId: 0
            };
            this.ticketingModel.callerName = this.workTicketDistributorInfo.name ? this.workTicketDistributorInfo.name : '';
            this.ticketingModel.sourceIdentifierValue =
                this.ticketingModel.sourceId === SourceType.Email ? response.email : response.phone;
            this.disableCreate = false;
            this.fboIdFound = true;
        } else {
            this.disableCreate = true;
            this.invalidMembersearch = true;
            this.fboIdFound = false;
        }
    }

    /**
     * @description search pooling (hitting service continuesly)
     * @date 2019-10-15
     * @param {*} response
     * @memberof EditWorkTicket
     */
    searchPolling(response: any) {
        if ((response.status === SearchResponseType.IN_PROGRESS) || (response.status === SearchResponseType.QUEUED)) {
            if (this.searchComponentSettings.pollCount < this.searchComponentSettings.maxPollCount) {
                this.searchComponentSettings.pollCount = this.searchComponentSettings.pollCount + 1;
                this.getSearchDistributorInfoFromAs400(response.location);
            } else {
                const message: any = this._translatePipe.get('ticketing-system.Member Not Exist');
                this._commonService.setNotification('', message.value, 'error', 0, true, 30);
                this.disableCreate = true;
                this.invalidMembersearch = true;
            }
        }
    }

    /**
   *
   *
   * @param {*} error
   * @memberof SearchComponent
   */
    searchErrorResponse(error: any) {
        this.isLoading = false;
        if (error.validations && error.validations.length > 0) {
            this._commonService.setNotification('', error.validations[0].message, 'error', 0, true, 30);
        }
    }
    getTicketById(ticketID: number) {
        this._customerservice.getTicketById(ticketID).subscribe((response) => {
            if (response) {
                this.ticketingModel = response;
                this.operatingCountryId = response.operatingCountryId;
                if (this.ticketingModel.countryId) {
                    this.isoCodeThree = this._commonService.getCountry(this.ticketingModel.countryId);
                }
                if (response.attachments) {
                    this.onloadAttachments = response.attachments;
                }
                if (this.ticketingModel.notes && this.ticketingModel.notes.length > 0) {
                    this.ticketingModel.notes.sort(function (item1, item2) {
                        const note1 = new Date(item1.createdDate).getTime(), note2 = new Date(item2.createdDate).getTime()
                        // sort string ascending
                        if (note1 > note2) {
                            return -1;
                        } else if (note1 < note2) {
                            return 1;
                        } else {
                            return 0;
                        }
                    });
                }
                if (this.ticketingModel.createdDate) {
                    this.ticketingModel.createdDate = moment.utc(this.ticketingModel.createdDate)
                        .utcOffset(this.storeInfo.timeZoneOffset * 60).format('DD-MMM-YYYY HH:mm:ss');
                }

                if (this.ticketingModel.notes) {
                    this.ticketingModel.notes.forEach(note => {
                        note.createdDate = moment.utc(note.createdDate)
                            .utcOffset(this.storeInfo.timeZoneOffset * 60).format('DD-MMM-YYYY HH:mm:ss');
                    });
                }
                if (this.ticketingModel.dueDate) {
                    this.ticketingModel.dueDate = moment.utc(this.ticketingModel.dueDate)
                        .utcOffset(0).format('DD-MMM-YYYY');
                }
                this.setDefaultForm();
            }
        });
    }

    /**
     * set form values on load
     */
    setDefaultForm() {
        if (this.onloadAttachments) {
            let attachments = this.onloadAttachments;
            this.existFiles = Object.assign([], attachments);
            this.attachmentsLength = this.existFiles.length;
            this.ticketingModel.attachments = this.onloadAttachments;
        }
        if (this.ticketingModel.dueDate) {
            this.dueDateFormat = new Date(this.ticketingModel.dueDate.split('T')[0])
            this.dueDate = this.momentConstructor(this.dueDateFormat);
        }
        this.getTicketStatuses();
        this.getBusinessEntities();
        this.getOperatingCountryById(this.ticketingModel.operatingCountryId);
        this.buildForm();
        this.getTicketTypesAndSubTypes();
        this.getAssignedUsersByDepartments(this.ticketingModel.departmentId);
        this.getDepartments();
        this.count = 0;
        this.attachmentsLength = 0;
        this.distributorInfo ? '' : this.getDistributorInfo(this.ticketingModel.memberId);
        this.uploader = this._customerService.getFileUploader();
        this.uploader.onErrorItem = () => this.onErrorItem();
        this.uploader.onSuccessItem = (item: any, response: any, status: any, headers: any) => this.onSuccessItem(response);
        this.fboSearchResultModel = null;
        this.workTicketDistributorInfo = Object.assign({}, this.distributorInfo);
        if (this.workTicketDistributorInfo && this.distributorInfo) {
            this.workTicketDistributorInfo.name = this.displayNamePipe.transform(this.distributorInfo);
        }
    }
    /*
   Get ticket Priorities
   */
    getTicketPriorities() {
        this._customerservice.getTicketPriorities().subscribe((response) => {
            if (response) {

                this.ticketPriorities = response;
            }
        });
    }
    /*
   set medium as default priority..
   */
    setDefaultPriority() {
        if (this.ticketPriorities && this.ticketPriorities.length > 0) {
            this.ticketEditForm.controls['priority'].setValue(Priority.Medium);
        }
    }
    getAssignedUsersByDepartments(event: any) {
        let departmentId = +event;

        if (!this.userInfo.hasSystemRole) {

            this.isTicketClosePermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBOManageTicketPermissions[0] + "]"), AccessLevel.Customer_Service);
            this.isTicketReopenPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.ManageDepartmentPermissions[1] + "]"), AccessLevel.Department, departmentId);
        } else {
            this.isTicketClosePermission = true;
            this.isTicketReopenPermission = true;

        }

        this.skipAssignToOnLoad ? '' : this.ticketEditForm.controls['assignTo'].setValue('');
        this.skipAssignToOnLoad = false;
        // if (!this.userInfo.hasSystemRole) {
        //     this.isTicketAssignPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBOManageTicketPermissions[0] + ']'), AccessLevel.Customer_Service);
        // } else {
        this.isTicketAssignPermission = true;
        //}
        // if (!this.isTicketAssignPermission) {
        //     this.ticketEditForm.controls['assignTo'].disable();
        //     this.users = [];
        //     this.ticketEditForm.controls['assignTo'].setValue('');
        // } else {
        this.ticketEditForm.controls['assignTo'].enable();
        if (departmentId) {
            this._customerservice.getAssignedUsersByDepartments(departmentId).subscribe(response => {
                if (response) {
                    this.users = response;
                    if (this.users && this.users.length > 0) {
                        this.users = this.users.sort(function (a, b) {
                            return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
                        });
                    }
                    this.assignToChange();
                } else {
                    this.users = [];
                    this.ticketEditForm.controls['assignTo'].setValue('');
                }
            });
        }
        // }
        if (departmentId === 0) {
            this.ticketEditForm.controls['assignTo'].enable();
            this.users = [];
            this.ticketEditForm.controls['assignTo'].setValue('');
            this.assignToChange();
        }
    }
    assignToChange() {
        if (!this.ticketEditForm.controls['assignTo'].value) {
            this.skipDueDateNStatusOnLoad ? '' : this.ticketEditForm.controls['dueDate'].setValue('');
        }
        if (this.ticketEditForm.controls['assignTo'].value) {
            this.showDatePicker = true;
            this.ticketEditForm.controls['dueDate'].enable();
        }
        else {
            this.showDatePicker = false;
            this.ticketEditForm.controls['dueDate'].disable();
            this.ticketEditForm.controls['dueDate'].setValidators([]);

        }
        this.ticketEditForm.controls['dueDate'].updateValueAndValidity();
        this.skipDueDateNStatusOnLoad = false;

    }
    getTicketTypesAndSubTypes(subtypesLoad?: boolean) {
        this.ticketTypes = [];
        let operatingCountry = this.ticketingModel.operatingCountryId;
        if (operatingCountry) {
            this.departmentService.getTicketTypesAndSubTypes(operatingCountry).subscribe(response => {
                if (response) {
                    this.ticketTypes = response;
                    this.ticketTypes.forEach(type => {
                        if (type.value) {
                            type.sortValue = type.value.toLowerCase();
                        }
                    });
                    const orderType = response.find((type: any) => type.value === TicketType.Order);
                    if (orderType) {
                        this.orderTypeId = orderType.id;
                    }
                    const productType = response.find((type: any) => type.value === TicketType.Product);
                    if (productType) {
                        this.productTypeId = productType.id;
                    }
                    if (!subtypesLoad) {
                        this.getSubTypes(this.ticketingModel.typeId);
                    }
                }
            });
        }
    }
    getSubTypes(event: any) {
        let ticketTypeId = +event;
        this.subTypes = [];
        this.enableLocationType = false;
        this.validWebOrderNumber = true;
        this.disableCreate = false;
        this.ticketEditForm.controls['orderId'].setValidators([]);
        this.ticketEditForm.controls['locationType'].setValidators([]);
        if (ticketTypeId) {
            let types: any[] = JSON.parse(JSON.stringify(this.ticketTypes))
            if (!this.onLoad) {
                this.ticketEditForm.controls['subType'].setValue('');
            }
            this.onLoad = false;
            this.subTypes = types.find(item => item.id === ticketTypeId).subTypes;
            if (ticketTypeId == this.orderTypeId) {
                this.subTypes = this.subTypes.filter((item) => { return (item.id !== SubtypesEnums.Dispute && item.id !== SubtypesEnums.Cancel); })
                this.ticketEditForm.controls['locationType'].setValue('');
            }
            else if (ticketTypeId == this.productTypeId) {
                this.ticketEditForm.controls['locationType'].setValidators([Validators.required]);
                this.enableLocationType = true;
            }
            if (ticketTypeId != this.productTypeId) {
                this.ticketEditForm.controls['locationType'].setValue('');
            }
        }
        this.ticketEditForm.controls['orderId'].updateValueAndValidity();
        this.ticketEditForm.controls['locationType'].updateValueAndValidity();
    }
    /**
     * get Departments by operating country id
     */
    getDepartments() {
        if (this.ticketingModel.operatingCountryId) {
            this._customerservice.getAllDepartmentsByOperatingCountryId(+this.ticketingModel.operatingCountryId).subscribe(response => {
                if (response) {
                    this.departments = response;
                    this.departments.sort(function (item1, item2) {
                        var dept1 = item1.value.toLowerCase(), dept2 = item2.value.toLowerCase()
                        if (dept1 < dept2) //sort string ascending
                            return -1
                        if (dept1 > dept2)
                            return 1
                        return 0
                    });
                    if (this.skipDeptOnLoad) {
                        let dept = this.departments.find((dept: any) => dept.id === this.ticketingModel.departmentId);
                        dept ? '' : this.ticketEditForm.controls['department'].setValue('');
                    }
                    else {
                        this.ticketEditForm.controls['department'].setValue('');
                    }
                    this.skipDeptOnLoad = false;
                } else {
                    this.departments = [];
                    this.ticketEditForm.controls['department'].setValue('');
                    this.getAssignedUsersByDepartments('');
                }
            });
        } else {
            this.departments = [];
            this.users = [];
        }
    }
    /*
   Get ticket Statuses
   */
    getTicketStatuses() {
        this._customerservice.getTicketStatus().subscribe((response) => {
            if (response) {
                this.initialStatuses = response;
                if (this.ticketingModel.statusId === Status.Closed) {
                    this.initialStatuses.forEach((status: any) => { if (status.id === Status.InProgress) { status.value = StatusConstants.Reopen } })
                    this.isTicketClosed = true;
                    this.statuses = this.initialStatuses;
                }
                else {
                    this.statuses = this.initialStatuses;
                }
                this.statuses = sortBy(this.statuses, 'value');
            }
        });
    }
    /*Check for max of 5 attachments */
    checkMaxAttachments() {
        if (this.uploader.queue) {
            this.attachmentsLength = this.uploader.queue.length + this.existFiles.length;
            if (this.attachmentsLength >= 5) {
                while (this.attachmentsLength > 5) {
                    this.uploader.queue[this.uploader.queue.length - 1].remove();
                    this.attachmentsLength--;
                }
            }
        }
    }
    sortTableByColumn(property: any) {
        this.isDesc = !this.isDesc; //change the direction
        this.sortColumn = property;
        let direction = this.isDesc ? 1 : -1;
        this.ticketActivityLogList.sort(function (a, b) {
            if (a[property] < b[property]) {
                return -1 * direction;
            }
            else if (a[property] > b[property]) {
                return 1 * direction;
            }
            else {
                return 0;
            }
        });
    };
    getTicketActivityLog(ticketID) {
        if (ticketID) {
            this._customerservice.getActivityLogByTicketId(ticketID).subscribe(response => {
                if (response) {
                    this.ticketActivityLogList = response;
                    if (this.ticketActivityLogList && this.ticketActivityLogList.length > 0) {
                        this.ticketActivityLogList.forEach(x => {
                            if (x.createDate) {
                                x.createDate = moment.utc(x.createDate)
                                    .utcOffset(this.storeInfo.timeZoneOffset * 60).format('DD-MMM-YYYY HH:mm:ss');
                            }
                        });
                    }
                }
            });
        }
    }
    /**
  * failed to upload file
  * @param item
  * @param response
  * @param status
  * @param headers
  */
    onErrorItem(): any {
        this.ngProgress.done();
        this._commonService.createNotification('', 'Failed to upload document. Please try after sometime ', NotificationType.ERROR);
    }
    /**
         * On Successful upload of file
         * @param item
         * @param response
         * @param status
         * @param headers
         */
    onSuccessItem(response: string): any {
        if (response) {
            let res = JSON.parse(response);
            let fileDetails = {
                'userId': this.userInfo.userId,
                'fileName': res.fileName.substr(0, 95),
                'url': res.url,
                'eTag': res.eTag,
                'key': res.key
            }
            this.uploadResponse.push(fileDetails);
            this.count++;
            if (this.uploader.queue.length === this.count) {
                this._commonService.createNotification('', 'File Uploaded Successfully', NotificationType.SUCCESS);

                this.ticket.attachments = this.ticket.attachments ?
                    this.ticket.attachments.concat(this.uploadResponse) : this.uploadResponse;
                this.saveTicket();
            }
        }
        else {
            this._commonService.createNotification('', 'File Not uploaded', NotificationType.ERROR);
        }
        this.ngProgress.done();
    }
    saveAttachments(attachments: any) {
        for (let i = 0; i < this.existFiles.length; i++) {
            let fileDetails = {
                'id': this.existFiles[i].id,
                'userId': this.userInfo.userId,
                'fileName': this.existFiles[i].fileName,
                'url': this.existFiles[i].url,
                'eTag': this.existFiles[i].eTag,
                'key': this.existFiles[i].key
            }
            attachments.push(fileDetails);
        }
        this._customerservice.saveAttachments(attachments, this.ticketingModel.id).subscribe(response => {
            if (response) {
                let res = response;
                let addedNotification: any = this._translatePipe.get('Ticket ' + this.ticketingModel.ticketNumber + ' has been Saved successfully');
                this._commonService.createNotification('', addedNotification.value, NotificationType.SUCCESS);
                if (this.ticketClosed) {
                    this.closeTicketById();
                }
                else if (this.ticketReopen) {
                    this.reopenTicketById();
                }
                else {
                    this.closeTab();
                }
            }
        });
    }
    closeTab(memberId?: string) {
        const tabinfo = new TicketTabInfo();
        tabinfo.distributorID = this.distributorInfo ? this.distributorInfo.distributorId : null;
        tabinfo.tabIndex = this.tabIndex;
        tabinfo.ticketID = this.ticketID;
        tabinfo.isTeamTicket = this.isTeamTicket;
        tabinfo.isFormTicket = this.isFormTicket;
        tabinfo.isFdTicket = this.isFdTicket;
        tabinfo.ticketNumber = this.ticketingModel.ticketNumber;
        if (memberId) {
            tabinfo.modifiedDistributor = (this.distributorInfo && memberId &&
                this.distributorInfo.distributorId === memberId) ? false : true;
        } else {
            tabinfo.modifiedDistributor = (this.distributorInfo && this.ticketResponse &&
                this.distributorInfo.distributorId === this.ticketResponse.memberId) ? false : true;
        }
        this._messageService.setClosingTabInfo(tabinfo);
    }
    updateTicket() {
        this.isSubmitted = true;
        this.disableCreate = true;
        const invalidFields: any = document.querySelectorAll('#Update-Ticket-js .ng-invalid');
        if (invalidFields[0]) {
            invalidFields[0].focus();
            this.disableCreate = false;
        }
        if (this.ticketEditForm.valid && (this.validWebOrderNumber || this.ticketEditForm.controls['orderId'].value.length == 0)) {
            let ticket = new CreateTicketRequest();
            let createTicketValues: any = this.ticketEditForm.getRawValue();
            if (this.isTicketAssignPermission && +createTicketValues.assignTo !== (this.userInfo.userId) &&
                (+createTicketValues.status === this.ticketingModel.statusId ||
                    (+createTicketValues.status !== Status.Closed && this.ticketingModel.statusId === Status.Closed && +createTicketValues.status !== Status.InProgress))) {
                if (this.isStatusChanged === true
                    && this.ticketingModel.statusId === Status.Closed
                    && +createTicketValues.status === Status.Closed) {
                    this.disableCreate = false;
                    this.isTicketClosed = false;
                    this.openCloseTicketModal(true);
                }
                else {
                    this.proceedToUpdate();
                }
            } else if (+createTicketValues.status !== Status.Closed && this.ticketingModel.statusId === Status.Closed) {
                this.disableCreate = false;
                if (+createTicketValues.status === Status.InProgress) {
                    if (this.isTicketReopenPermission) {
                        if (this.isStatusChanged === false) {
                            this.isTicketClosed = true;
                            this.openCloseTicketModal(false);
                        }
                        else {
                            this.proceedToUpdate();
                            this.isStatusChanged = false;
                        }
                    } else {
                        this.displayAlertBoxOnNoPermissiononReopenTicket(true);
                    }
                } else {
                    this.isTicketClosed = true;
                    this.openCloseTicketModal(true);
                }
            } else if (+createTicketValues.status === Status.Closed) {
                if (this.isStatusChanged === true) {
                    this.disableCreate = false;
                    this.isTicketClosed = false;
                    this.openCloseTicketModal(true);
                }
                else {
                    this.proceedToUpdate();
                }
            } else {
                this.proceedToUpdate();
            }
        }
        else if (!this.validWebOrderNumber && this.ticketEditForm.controls['orderId'].value.length > 0) {
            this.orderNotFound();
        }
    }
    proceedToUpdate() {
        let createTicketValues: any = this.ticketEditForm.getRawValue();
        let fboId: string;
        if (this.ticketEditForm.controls['memberId'].value) {
            fboId = this.ticketEditForm.controls['memberId'].value;
            fboId = fboId.replace(/-|\s/g, '');
            this.ticket.memberId = fboId;
            this.ticket.callerName = this.ticketingModel.callerName;

        } else {
            this.ticket.memberId = null;
            this.ticket.memberType = null;
            this.ticket.callerName = null;
        }
        this.ticket.sourceId = this.ticketingModel.sourceId;
        this.ticket.callerName = this.ticketingModel.callerName;
        this.ticket.operatingCountryId = createTicketValues.operatingCountry;
        this.ticket.typeId = createTicketValues.ticketType;
        this.ticket.attachments = this.ticketingModel.attachments;
        this.ticket.subTypeId = createTicketValues.subType;
        this.ticket.description = createTicketValues.description;
        this.ticket.departmentId = +createTicketValues.department;
        this.ticket.ticketNumber = this.ticketingModel.ticketNumber;
        this.ticket.priorityId = createTicketValues.priority;
        this.ticket.dueDate = createTicketValues.dueDate ? Utils.convertToSpecificDateFormat(createTicketValues.dueDate, DateConstants.DOBFormat) : null;
        this.ticket.subject = createTicketValues.subject;
        this.ticket.assignedToId = createTicketValues.assignTo;
        this.ticket.sourceIdentifierValue = createTicketValues.sourceIdentifierValue;
        this.ticket.distributorName = this.ticket.memberId ? this.workTicketDistributorInfo.name : null;
        this.ticket.agentEmail = this.userInfo.email;
        this.ticket.agentEmail = this.userInfo.email;
        this.ticket.agentName = this.userInfo.firstName + ' ' + this.userInfo.lastName;
        this.ticket.ticketLink = window.location.href;
        this.ticket.countryId = this._commonService.getCountry(this.isoCodeThree, true);
        if (this.users && this.ticket.assignedToId) {
            const assignedToUser = this.users.find(item => item.id === +this.ticket.assignedToId);
            if (assignedToUser) {
                this.ticket.assignedToEmail = assignedToUser.email;
            }
        }
        const distributorInfo = (fboId && this.workTicketDistributorInfo && this.workTicketDistributorInfo.memberType)
            ? this.workTicketDistributorInfo : (fboId && this.distributorInfo ? this.distributorInfo : null);
        if (distributorInfo) {
            if (distributorInfo.memberType === MemberType.RETAIL || distributorInfo.memberType === MemberType.RETAIL_CUSTOMER
                || distributorInfo.memberType === MemberType.RETAILCUSTOMER) {
                this.ticket.memberType = MemberType.RETAIL;
            } else if (distributorInfo.memberType === MemberType.GUEST || distributorInfo.memberType === 'G') {
                this.ticket.memberType = MemberType.GUEST;
            } else if (distributorInfo.memberType === MemberType.FPC) {
                this.ticket.memberType = MemberType.FPC;
            } else {
                this.ticket.memberType = MemberType.FOB;
            }
        }
        this.ticket.sendMailNotification = this.ticketEditForm.value.sendMailNotification;
        this.ticket.userId = this.userInfo.userId;
        this.ticket.firstName = this.userInfo.firstName;
        this.ticket.lastName = this.userInfo.lastName;
        this.ticket.statusId = createTicketValues.status;
        this.ticket.note = createTicketValues.notes;
        this.ticket.id = this.ticketingModel.id;
        this.ticket.createdBy = this.ticketingModel.createdBy;
        this.ticket.updatedBy = this.userInfo.userId;
        this.enableLocationType ? this.ticket.locationTypeId = createTicketValues.locationType : '';
        this.ticket.orderId = createTicketValues.orderId ? createTicketValues.orderId : '';
        this.ticket = this.mapCopyToUsers();
        if (this.uploader.queue.length > 0) {
            this.uploadFile();
        } else {
            this.saveTicket();
        }
    }

    /**
     * @description This method used to map copyTo users in ticket model
     * @date 2019-11-19
     * @memberof DisputeTicket
    */
    mapCopyToUsers(): CreateTicketRequest {
        this.ticket.copyToUsers = [];
        if (this.ticketEditForm.value.copyTo && this.ticketEditForm.value.copyTo.length) {
            this.ticketEditForm.value.copyTo.forEach(item => {
                const user: CopyToUser = {
                    userId: item.userId,
                    username: item.username,
                    firstName: item.firstName,
                    lastName: item.lastName
                };
                this.ticket.copyToUsers.push(user);
            });
        }
        return this.ticket;
    }


    workTicketEditTransformDate(date: any) {
        const dateMomentObj = Utils.convertToSpecificDateFormat(date, DateConstants.DateFormat);
        if (dateMomentObj) {
            if (this.ticketEditForm.controls['dueDate'].dirty) {
                this.ticketEditForm.controls['dueDate'].setValidators([Utils.validateDate]);
            }
            if (this.ticketEditForm.controls['dueDate'].valid) {
                this.ticketEditForm.controls['dueDate'].setValue(moment(dateMomentObj, 'DD-MMM-YYYY'));
            }
        } else {
            this.ticketEditForm.controls['dueDate'].setValue('');
        }
    }
    closeForm() {
        if (this.isTicketClosed) {
            this.ticketCloseForm = this._formbuilder.group(
                {
                    closedTicketReason: [''],
                    closedTicketNote: ['', [Validators.required]]
                });
        } else {
            this.ticketCloseForm = this._formbuilder.group({
                closedTicketReason: ['', [Validators.required]],
                closedTicketNote: ['', [Validators.required]]
            });
        }
    }
    openCloseTicketModal(isCloseTicket: boolean) {
        this.closeForm();
        if (!this.userInfo.hasSystemRole) {
            if (isCloseTicket) {
                if (this.isTicketClosePermission) {
                    this.closeTicketPopup.open();
                } else {
                    if (this.ticketingModel.statusId === Status.Closed) {
                        this.closeTicketPopup.open();
                    } else {
                        this.displayAlertBoxOnNoPermissiononCloseTicket(true);
                    }
                }
            } else {
                let createTicketValues: any = this.ticketEditForm.getRawValue();
                if (+createTicketValues.assignTo !== (this.userInfo.userId)) {
                    this.displayAlertBoxOnNoPermissiononReopenTicket(false);
                }
            }
        } else {
            this.closeTicketPopup.open();
        }
    }
    displayAlertBoxOnNoPermissiononCloseTicket(hasPermission: Boolean) {
        this.deleteModal.toggle = true;
        if (hasPermission) {
            this.deleteModal.message = CommonMessage.noPermissionToCloseMessage;
        } else {
            this.deleteModal.message = CommonMessage.noCloseTicketPermissionMessage;
        }

    }
    displayAlertBoxOnNoPermissiononReopenTicket(hasPermission: Boolean) {
        this.deleteModal.toggle = true;
        if (hasPermission) {
            this.deleteModal.message = CommonMessage.noPermissionToReOpenMessage;
        } else {
            this.deleteModal.message = CommonMessage.noReopenTicketPermissionMessage;
        }
    }
    saveTicket() {
        this._customerservice.updateTicketById(this.ticketID, this.ticket).subscribe(response => {
            if (response) {
                this.isSubmitted = false;
                this.ticketResponse = response;
                this._messageService.setAuditLogUpdated(true);
                this.disableCreate = false;
                let addedNotification: any = this._translatePipe.get('Ticket ' + this.ticketResponse.ticketNumber + ' has been Updated successfully');
                this._commonService.createNotification('', addedNotification.value, NotificationType.SUCCESS);
                if (this.ticketClosed) {
                    this.closeTicketById();
                } else if (this.ticketReopen) {
                    this.reopenTicketById();
                } else {
                    this.closeTab();
                }
            }
        });
    }
    /**
       * Upload file
       */
    uploadFile() {
        if (this.uploader && this.uploader.queue.length > 0) {
            this.ngProgress.start();
            let filelength = this.ticketingModel && this.ticketingModel.attachments && this.ticketingModel.attachments.length || 0;
            let ticketNumber = this.ticketingModel.id;
            this.uploader.onBuildItemForm = (item: any, form: any) => {
                filelength++;
                item.withCredentials = false;
                item.uploader.authToken = this._customerService.getAuthorizationToken();
                const fileNameArr = item.file.name.split('.');
                item.file.name = fileNameArr[0] + '_' + ticketNumber + '_' + filelength
                    + (fileNameArr.length > 1 ? '.' + fileNameArr[fileNameArr.length - 1] : '');
                form.append('fileName', decodeURIComponent(encodeURIComponent(item.file.name)));
                form.append('path', 'content/customer-service/' + this.ticketingModel.operatingCountryId + '/');
            };
            for (let i = 0; i < this.uploader.queue.length; i++) {
                this.uploader.queue[i].upload();
            }
        }
    }
    // get location types and display when product is selected
    getLocationTypes() {
        this._customerservice.getLocationTypes().subscribe(response => {
            if (response) {
                this.locationTypes = response;
                this.setFocusToTextBox();
            }
        });
    }
    /**
     * get ticket closing reasons
     */
    getClosedReasons() {
        this._customerservice.getClosedReasons().subscribe((response) => {
            if (response) {
                this.closedReasons = response;
            }
        });
    }
    doNotRemoveFormData() {
        //data should not be removed...
    }
    closeTicket() {
        this.modelSubmit = true;
        if (this.ticketCloseForm.valid) {
            this.ticketClosed = true;
            this.proceedToUpdate();
        }
    }
    closeTicketById() {
        let formValues = this.ticketCloseForm.getRawValue();
        let ticketInfo = new CreateTicketRequest();
        ticketInfo.closeReasonId = formValues.closedTicketReason;
        ticketInfo.closeReason = formValues.closedTicketNote;
        ticketInfo.id = this.ticketingModel.id;
        ticketInfo.userId = this.userInfo.userId;
        this._customerservice.closeTicketById(this.ticketID, ticketInfo).subscribe(response => {
            if (response) {
                this.closeTab();
            }
        });
    }
    reopenTicket() {
        this.modelSubmit = true;
        if (this.ticketCloseForm.valid) {
            this.ticketReopen = true;
            this.proceedToUpdate();
        }
    }
    reopenTicketById() {
        let formValues = this.ticketCloseForm.getRawValue();
        let ticketInfo = new CreateTicketRequest();
        ticketInfo.reopenReason = formValues.closedTicketNote;
        ticketInfo.id = this.ticketingModel.id;
        ticketInfo.userId = this.userInfo.userId;
        this._customerservice.reopenTicketById(this.ticketID, ticketInfo).subscribe(response => {
            if (response) {
                this.closeTab();
            }
        });
    }
    /**
     * close the popup
     */
    cancelPopup() {
        this.isSubmitted = false;
        this.modelSubmit = false;
        this.ticketCloseForm.patchValue({ 'closedTicketReason': '' });
        this.ticketCloseForm.patchValue({ 'closedTicketNote': '' });
        this.closeTicketPopup.close();
    }
    /*
     * for downloading the attachment
    */
    downloadDocument(url: string, fileName: string) {
      if (this.enableFileUploadToPrivate) {
        let path = new URL(url).pathname.slice(1);
        let s3Path = path.slice(0, path.lastIndexOf("/") + 1);
        this._customerService.downloadFile(s3Path, fileName).subscribe(blob => {
          importedSaveAs(blob, fileName);
          let downlaodNotification: any = this._translatePipe.get('Attachment  has been downloaded successfully');
          this._commonService.createNotification('', downlaodNotification.value, NotificationType.SUCCESS);
        }, err => {
          let downloadNotification: any = this._translatePipe.get("Something Went Wrong, Please try again after some time");
          this._commonService.createNotification("", downloadNotification.value, NotificationType.ERROR);
        });
      } else {
        this._customerService.downloadDocument(url, fileName).subscribe(blob => {
          importedSaveAs(blob, fileName);
          let downlaodNotification: any = this._translatePipe.get('Attachment  has been downloaded successfully');
          this._commonService.createNotification('', downlaodNotification.value, NotificationType.SUCCESS);
        });
      }
    }

    removeExistFiles(key: any, index: number) {
        this.existFiles.splice(index, 1);
        this.attachmentsLength = this.attachmentsLength - 1;
        this.ticketingModel.attachments = this.ticketingModel.attachments.filter(element => {
            return element.key !== key;
        });
    }
    /**
   * get member info
   */
    getDistributorInfo(memberId: string) {
        if (memberId) {
            this._customerservice.getFBOProfileInfoFromTitan(memberId).subscribe(response => {
                if (response && response.isSuccess) {
                    this.distributorInfo = response;
                    if (response.firstName && response.lastName) {
                        const middleName = response.displayMiddleName && response.middleName ? response.middleName : '';
                        this.distributorInfo.name = response.firstName + ' ' + (middleName ? middleName + ' ' : '') + response.lastName;
                    }
                    this.distributorInfo.memberType = response.memberType;
                    this.distributorInfo.contactNumber = response.contactNumber;
                    this.distributorInfo.email = response.email;
                    this.distributorInfo.level = response.level;
                    if (response.fboId) {
                        this.distributorInfo.distributorId = response.fboId;
                    }
                    this.preloadDistributorInfo();
                } else {
                    this.getDistributorInfoFromAs400(memberId);
                }
            }, (error: any) => {
                this.getDistributorInfoFromAs400(memberId);
            });
        }
    }

    getDistributorInfoFromAs400(distributorId: string) {
        if (distributorId) {
            this._customerservice.getFBOProfileInformation(distributorId, this.ticketingModel.memberType).subscribe(response => {
                if (response) {
                    this.distributorInfo = new DistributorInfo();
                    this.distributorInfo.name = response.firstName + ' ' + response.lastName;
                    this.distributorInfo.distributorId = distributorId;
                    this.distributorInfo.memberType = this.ticketingModel.memberType;
                    this.distributorInfo.level = response.level;
                    this.preloadDistributorInfo();
                }
            });
        }
    }

    private preloadDistributorInfo(): void {
        if (this.distributorInfo) {
            this.workTicketDistributorInfo = JSON.parse(JSON.stringify(this.distributorInfo));
            this.workTicketDistributorInfo.name = this.displayNamePipe.transform(this.distributorInfo);
        }
    }

    clearTicketForm() {
        this.onLoad = true;
        this.skipDueDateNStatusOnLoad = true;
        this.skipAssignToOnLoad = true;
        this.skipDeptOnLoad = true;
        this.setDefaultForm();
        if (this.distributorInfo) {
            this.closeTab(this.distributorInfo.distributorId);
        } else {
            this.closeTab();
        }
    }
    setFocusToTextBox() {
        setTimeout(function () {
            document.getElementById('ticketType').focus();
        }, 1000);
    }
    openTicketActivityModal(changedData: String) {
        if (changedData) {
            this.ticketActivityChangeData = changedData;
            this.ticketActivityDetailsModal.open();
        } else {
            this.ticketActivityChangeData = '';
        }
    }
    closeTicketActivityPopup() {
        this.ticketActivityDetailsModal.close();
    }

    closeEditTicketCancelConfirmationPopup() {
        this.editTicketCancelConfirmationModal.close();
    }

    openEditTicketCancelConfirmationPopup() {
        this.editTicketCancelConfirmationModal.open();
    }
    /**
     * Gets fbo / retail oder information from titan
     */
    getRecentOrderInformation() {
        if (this.ticketEditForm.controls['orderId'].valid && this.ticketEditForm.controls['orderId'].value) {
            this.disableCreate = true;
            this.validWebOrderNumber = false;
            this.inValidOrderNumber = false;
            let webOrderId = this.ticketEditForm.controls['orderId'].value;
            webOrderId = webOrderId.toUpperCase();
            webOrderId = webOrderId.trim();
            if (webOrderId && webOrderId.length > 0) {
                this._orderservice.getRecentOrderInformation(webOrderId, this.isoCodeThree).subscribe(response => {
                    if (response && response.webOrderId) {
                        if (webOrderId !== response.webOrderId) {
                            this.orderNotFound();
                            return;
                        }
                        this.validWebOrderNumber = true;
                        this.disableCreate = false;
                        this.inValidOrderNumber = false;
                        let addedNotification: any = this._translatePipe.get('Web Order Number validated');
                        this._commonService.createNotification('', addedNotification.value, NotificationType.SUCCESS);
                    }
                    else {
                        this.getOrderDetails(webOrderId);
                    }
                }, error => {
                    this.getOrderDetails(webOrderId);
                });
            }
        }
    }
    /**
    * get order details to validate web order id using AS400
    */
    getOrderDetails(webOrderId: string) {
        this._customerservice.getOrderInfoUsingWebOrderNum(webOrderId, this.isoCodeThree).subscribe(response => {
            if (response) {
                if (webOrderId !== response.webOrderNumber) {
                    this.orderNotFound();
                    return;
                }
                this.validWebOrderNumber = true;
                this.disableCreate = false;
                this.inValidOrderNumber = false;
                let addedNotification: any = this._translatePipe.get('Web Order Number validated');
                this._commonService.createNotification('', addedNotification.value, NotificationType.SUCCESS);
            }
        }, error => {
            this.disableCreate = false;
            this.orderNotFound();
        });
    }
    /**
    * notification if order not found
    */
    orderNotFound() {
        this.disableCreate = true;
        this.inValidOrderNumber = true;
        let addedNotification: any = this._translatePipe.get('Order not found');
        this._commonService.createNotification('', addedNotification.value, NotificationType.ERROR);

    }

    /**
     * @description This method used to get users by search text
     * @date 2019-11-19
     * @memberof DisputeTicket
    */
    requestAutocompleteItems = (searchText: string): Observable<any> => {
        const userSearchList: CopyToUserResponse[] = [];
        const url = ApiUrlConstants.enrollmentApigwUrl + 'csp-agents/search?keyword=' + searchText + '&batchSize=10&pageNumber=1';
        const positionTimeout = 0;
        return this._http
            .get(url)
            .map(res => {
                const response: CopyToSearchResponse = res.json();
                if (response && response.content && response.content.length) {
                    response.content.forEach(item => {
                        const user = {
                            value: item.firstName + ' ' + item.lastName + ' ' + item.username,
                            display: item.firstName + ' ' + item.lastName + ' ' + item.username,
                            displayName: item.firstName + ' ' + item.lastName, firstName: item.firstName,
                            lastName: item.lastName, userId: item.userId, username: item.username
                        };
                        userSearchList.push(user);
                    });
                }
                this.setOffsetPosition(positionTimeout);
                return userSearchList;
            });
    }

    /**
   * @description This method used to get users by search text
   * @date 2019-11-19
   * @memberof CreateWorkTicket
  */
    setOffsetPosition(positionTimeout: any): void {
        clearTimeout(positionTimeout);
        positionTimeout = setTimeout(() => {
            const tagInput: any = document.querySelector('.copy_to__block .ng2-tag-input__text-input');
            const dropdownElement: any = document.querySelector('.copy_to__block .ng2-dropdown-menu');
            if (tagInput) {
                dropdownElement.style.left = (12 + tagInput.offsetLeft) + 'px';
            }
        }, 0);
    }
    navigateToFBOProfile(): void {
        if (this.workTicketDistributorInfo) {
            this.DistributorInfo = this.workTicketDistributorInfo;
        } else if (this.fboProfileDetail) {
            this.DistributorInfo = this.fboProfileDetail;
        }
        this._commonService.getMemberStatus(this.DistributorInfo.fboId).subscribe(accountInfo => {
            if (accountInfo && accountInfo.status === AccountRestrictionStatus.RESTRICTED && !this.accountViewPermission) {
                this.accountRestriction = true;
                const memberlevel = this._commonService.getMemberLevel(this.DistributorInfo.memberLevelID);
                const memberDetails = {
                    fboId: this.DistributorInfo.fboId,
                    firstName: this.DistributorInfo.firstName,
                    lastName: this.DistributorInfo.lastName,
                    memberLevel: memberlevel
                };
                this.memberDetails = memberDetails;
                this.ticketEditForm.controls['memberId'].setValue('');
            } else {
                this.getFBOInfoProfile();
            }
        })
    }

    getFBOInfoProfile(){
        if (this.workTicketDistributorInfo) {
            this._cacheService.setSessionValue(CacheKey.DistributorInfo, this.workTicketDistributorInfo);
            window.open(window.location.origin + '/customerservice/search', '_blank');
        } else if (this.fboProfileDetail) {
            this._cacheService.setSessionValue(CacheKey.FboProfileDetail, this.fboProfileDetail);
            window.open(window.location.origin + '/customerservice/search', '_blank');
        }
    }

    getBusinessEntities() {
        this._customerservice.getAllBusinessEntities().subscribe(response => {
            if (response) {
                this.businessEntities = response;
                this.getAllowedCountries();
            }
        });
    }

    getAllowedCountries() {
        let countryIds: any = [];
        if (!this.userInfo.hasSystemRole) {
            if (this.userInfo.allowedOperatingCountries) {
                countryIds = this.userInfo.allowedOperatingCountries.split(",");
                if (this.userInfo.privileges.departments) {
                    countryIds.push.apply(countryIds, this.userInfo.privileges.departments.map(function (a) { return a.allowedOperatingCountries; }));
                }
                countryIds = countryIds ? countryIds : [];
                if (countryIds.length > 0) {
                    var ids = countryIds;
                    this.countries = this.businessEntities.filter(function (item) {
                        return ids.indexOf(item.id + "") != -1;
                    });
                }
            }
            else {
                this.countries = this.businessEntities;
            }
        }
        else {
            this.countries = this.businessEntities;
        }
        this.countries.sort(function (item1, item2) {
            var country1 = item1.name.toLowerCase(), country2 = item2.name.toLowerCase()
            if (country1 < country2) //sort string ascending
                return -1
            if (country1 > country2)
                return 1
            return 0
        });
        let usaInfo = this.countries.find((country: any) => country.id === OperatingCountryEnums.USA);
        if (usaInfo) {
            this.countries.splice(this.countries.indexOf(usaInfo), 1);
            this.countries.splice(0, 0, usaInfo);
        }

    }
    /**
        * @description getting countries under operating country
        * @date 2020-10-30
        * @param {string} countryCode
        * @memberof EditWorkTicket
       */
    getAllCountries(countryCode: string): void {
        this._customerservice.getCountriesByOperatingCountry(countryCode).subscribe(response => {
            if (response && response.countriesUnderOperatingCountry.length) {
                this.allCountries = response.countriesUnderOperatingCountry.filter(country => country.countryCode === country.companyCode);
            }
        });
    }

    /**
         * @description injecting isocodethree of the selected country
         * @date 2020-10-30
         * @param {string} countryCode
         * @memberof CreateDisputeTicket
         */
    getCountryIsoCodeThree(countryCode: string, isCountryChange?: Boolean) {
        if (this.allCountries) {
            this.isoCodeThree = this.allCountries.find((country: any) => country.countryCode === countryCode).companyCode;
        }
        if (this.ticketEditForm.controls['orderId'] && this.ticketEditForm.controls['orderId'].value && isCountryChange) {
            this.getRecentOrderInformation();
        }
    }

    operatingCountryChange(id: any, isCountryChange?: Boolean): void {
        if (id) {
            if (this.countries && this.countries.length) {
                const selectedCountry = this.countries.find((country: Country) => country.id === +id);
                if (selectedCountry) {
                    this.getAllCountries(selectedCountry.value);
                }
            }
            this.ticketingModel.operatingCountryId = id;
            this.ticketEditForm.controls['country'].setValue('');
            this.ticketEditForm.controls['ticketType'].setValue('');
            this.ticketEditForm.controls['subType'].setValue('');
            this.ticketEditForm.controls['department'].setValue('');
            this.ticketEditForm.controls['assignTo'].setValue('');
            this.uploader = this._customerservice.getFileUploader();
            this.uploader = this._customerservice.getFileUploader();
            this.uploader.onErrorItem = () => this.onErrorItem();
            this.uploader.onSuccessItem = (item: any, response: any, status: any, headers: any) => this.onSuccessItem(response);
            this.getTicketTypesAndSubTypes(true);
            this.getDepartments();
            if (this.ticketEditForm.controls['orderId'] && this.ticketEditForm.controls['orderId'].value && isCountryChange) {
                this.getRecentOrderInformation();
            }

        }
    }

    /**
    * To get focus for orderId field
    */

    onFocusOrderId(): void {
        this.inValidOrderNumber = false;
        if (this.ticketEditForm.valid) {
            this.disableCreate = false;
        }

    }

    /**
    * To get validation for enable and disable the update button
    */
    getValidationForUpdateBtn() {
        if (this.ticketEditForm.valid) {
            this.disableCreate = false;
        }
        else {
            this.disableCreate = true;
        }
        return this.disableCreate ? true : false;
    }

}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/work-ticket-edit.component.ts